import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import usePinnedItem from '@/hooks/use-pinned-item';
import {
  SEARCH_PARAM_DRAWER,
  SEARCH_PARAM_LOCK_PIN,
  SEARCH_PARAM_LOCK_PIN_SECTION_ID,
  SEARCH_PARAM_LOCK_PIN_TYPE,
  SEARCH_PARAM_ROUTE_LINE_NUMBER,
  SEARCH_PARAM_ROUTE_TYPE,
  SEARCH_PARAM_ROUTES,
  SEARCH_PARAM_SELECTED_DATE,
  SEARCH_PARAM_SHOW,
  SEARCH_PARAM_SORT_BY,
  SEARCH_PARAM_STATION_ID,
  SEARCH_PARAM_STATIONS,
  SEARCH_PARAMS_ROUTE_ID,
} from '@/utils/constants/queries';

export const useDrawerSearchParams = () => {
  const [searchParam, setSearchParams] = useSearchParams();

  const { pinnedItemId, pinnedItemType } = usePinnedItem();

  const isStation = pinnedItemType === 'station';
  const isRoute = pinnedItemType === 'route';
  const routeType = searchParam.get(SEARCH_PARAM_ROUTE_TYPE);
  const routeNumber = searchParam.get(SEARCH_PARAM_ROUTE_LINE_NUMBER);

  const handleRemoveDrawer = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete(SEARCH_PARAM_DRAWER);

      if (pinnedItemId) {
        if (isStation) {
          prev.set(SEARCH_PARAM_STATION_ID, pinnedItemId);
          prev.set(SEARCH_PARAM_SHOW, SEARCH_PARAM_STATIONS);
        } else if (isRoute) {
          prev.set(SEARCH_PARAMS_ROUTE_ID, pinnedItemId);
          prev.set(SEARCH_PARAM_SHOW, SEARCH_PARAM_ROUTES);
        }
      }

      if (routeType) {
        prev.delete(SEARCH_PARAM_ROUTE_TYPE);
      }

      if (routeNumber) {
        prev.delete(SEARCH_PARAM_ROUTE_LINE_NUMBER);
      }

      return prev;
    });
  }, [pinnedItemId, isStation, isRoute, routeType, routeNumber]);

  const handleToggleLockPin = useCallback(() => {
    setSearchParams((prev) => {
      if (prev.has(SEARCH_PARAM_LOCK_PIN)) {
        prev.delete(SEARCH_PARAM_LOCK_PIN);
        prev.delete(SEARCH_PARAM_LOCK_PIN_TYPE);
        prev.delete(SEARCH_PARAM_LOCK_PIN_SECTION_ID);
        prev.delete(SEARCH_PARAM_DRAWER);
        prev.delete(SEARCH_PARAM_ROUTE_TYPE);
        prev.delete(SEARCH_PARAM_SORT_BY);
        prev.delete(SEARCH_PARAM_SELECTED_DATE);
      }

      return prev;
    });
  }, []);

  return {
    pinnedItemId,
    pinnedItemType,
    isStation,
    handleRemoveDrawer,
    handleToggleLockPin,
  };
};
